import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { DownloadProgress } from './DownloadProgress';
import { useDownloadManagerContext } from '../contexts/DownloadManagerContext';
import { useNetworkHealth } from '../hooks/useNetworkHealth';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const {
    downloads,
    cancelDownload,
    retryDownload,
    pauseDownload,
    resumeDownload,
    clearCompleted,
  } = useDownloadManagerContext();
  const networkHealth = useNetworkHealth(true);

  return (
    <div className="app-layout">
      <div className="app-layout-grid">
        <Sidebar />
        <div className="app-main-stack">
          <Header />
          <div className="layout-content">{children}</div>
        </div>
      </div>
      <DownloadProgress
        downloads={downloads}
        onCancel={cancelDownload}
        onRetry={retryDownload}
        onPause={pauseDownload}
        onResume={resumeDownload}
        onClearCompleted={clearCompleted}
        networkHealth={networkHealth}
      />
    </div>
  );
};

export default Layout;
